<ax-value-view-label [label]="label">
  <ax-image-source class="image" [source]="'/staticFiles/pageFiles/' + id">
    <ax-icon class="icon" name="image"></ax-icon>
  </ax-image-source>
</ax-value-view-label>
